const doc = [({"da":({"js":({"input_validator":({"validators":({"presence":({"name_must_be_present":"%{name} skal være til stede."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;